// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter '$locale' implicitly has an 'any' type.
const ParseDate = ($locale, translationService) => ({
   require: 'ngModel',

   link(scope: any, element: any, attrs: any, ngModel: any) {
      const model = ngModel

      const localeShortDate = $locale.DATETIME_FORMATS.shortDate

      // Supported formats
      const cnFormat = new RegExp(`\
^(y+)[\\.\\-\\/]{1}\
(M{1,2})[\\.\\-\\/]{1}\
(d{1,2})$\
`)
      const euFormat = new RegExp(`\
^(d{1,2})[\\.\\-\\/]{1}\
(M{1,2})[\\.\\-\\/]{1}\
(y+)$\
`)
      const knFormat = new RegExp(`\
^(y+)[\\.\\-\\/]{1}\
\\s{1}(M{1})[\\.\\-\\/]{1}\
\\s{1}(d{1})[\\.]{1}$\
`)
      const usFormat = new RegExp(`\
^(M{1,2})[\\.\\-\\/]{1}\
(d{1,2})[\\.\\-\\/]{1}\
(y+)$\
`)
      const monthYearPattern = new RegExp(`\
^(\\d{1,2})[\\.\\-\\/]{1}\
(\\d{4})$\
`)
      const dayMonthYearPattern = new RegExp(`\
^(\\d{1,2})[\\.\\-\\/]{1}\
(\\d{1,2})[\\.\\-\\/]{1}\
(\\d{4}|\\d{2})$\
`)
      const yearMonthDayPattern = new RegExp(`\
^(\\d{4}|\\d{2})[\\.\\-\\/]{1}\
\\s{0,1}(\\d{1,2})[\\.\\-\\/]{1}\
\\s{0,1}(\\d{1,2})[\\.]{0,1}$\
`)
      const yearPattern = new RegExp(`\
^(\\d{4})$\
`)

      const valid = function(type = 'parseDate'){
         if (element[0] && (element[0].id === "sliderTo" || element[0].id === "sliderFrom")) { 
            if (!model.$viewValue) {
               model.$setValidity(type, true)
               return true
            }
         }
         element[0].setCustomValidity?.("")
         model.$setValidity(type, true)
         return true
      }

      const invalid = function(type = 'parseDate', msg = translationService.translations.ENTER_VALID_DATE){
         element[0].setCustomValidity?.(msg)
         model.$setValidity(type, false)
         return true
      }

      const localeBaseReturns = (month: any, day: any, year: any)=> {
         const currentYear = parseInt(String(new Date().getFullYear()).substr(2)) // 2 digit current year
         year = parseInt(year)
         if (year < 100) { year += (year > currentYear ? 1900 : 2000) }
         return valid() && new Date(year, parseInt(month) - 1, parseInt(day))
      }

      return model.$parsers.unshift(function(viewValue: any) {
         const dateString = model.$viewValue

         // Well Parsed Date
         viewValue = (function(viewValue) {

            // Pass through if date is from popup
            let day
            if (typeof dateString === "object") { return (valid() && viewValue) }
            if (dateString === "") {
               if (element[0] && (element[0].id === "sliderTo" || element[0].id === "sliderFrom")) { // handle case when sliderTo is empty                  
                  valid()
                  if (attrs.minDate != null) {
                     let value = scope
                     for (var objName of attrs.minDate.split('.')) { value = value[objName] }
                     valid('minDate')
                     valid('date')                     
                  }
                  if (attrs.maxDate != null) {
                     let value = scope
                     for (var objName of attrs.maxDate.split('.')) { value = value[objName] }
                     valid('maxDate')
                     valid('date')
                  }
                  return ""
               }
               return (valid() && viewValue) 
            }

            // Handle year pattern
            switch (true) {  
               case !!dateString.match(yearPattern):
                  var isFrom = element.attr('id').match(/from/i)
                  if (isFrom) { return (valid() && new Date(parseInt(dateString), 0)) }
                  return (valid() && new Date(parseInt(dateString), 11, 31, 11, 59, 59))
                  break

               // Handle month/year pattern
               case !!dateString.match(monthYearPattern):
                  var [month, year] = dateString.match(monthYearPattern).slice(1, 3)
                  if (month > 12) { return (invalid() && viewValue) }
                  return (valid() && new Date(parseInt(year), parseInt(month) - 1))
                  break

               // Handle month/day/year pattern
               case !!dateString.match(dayMonthYearPattern) && (!!localeShortDate.match(euFormat) || !!localeShortDate.match(usFormat)):
                  // European format
                  if (localeShortDate.match(euFormat)) {
                     [day, month, year] = dateString.match(dayMonthYearPattern).slice(1, 4)
                  // Us format
                  } else {
                     [month, day, year] = dateString.match(dayMonthYearPattern).slice(1, 4)
                  }
                  return localeBaseReturns(month, day, year)
                  break

               // Handle year/month/day pattern
               case (!!dateString.match(yearMonthDayPattern) && !!localeShortDate.match(cnFormat)) || !!localeShortDate.match(knFormat):
                  [year, month, day] = dateString.match(yearMonthDayPattern).slice(1, 4)
                  return localeBaseReturns(month, day, year)
                  break
            }

            // For browser standardized date just must pass supported formats otherwise undefined
            return invalid() && undefined
         })(viewValue)

         if (viewValue === "") {
            return ""
         }

         if (!viewValue) { return undefined }

         // minDate
         if (attrs.minDate != null) {
            viewValue = (function(viewValue){
               let value = scope
               for (var objName of attrs.minDate.split('.')) { value = value[objName] }
               if (_.isDate(value)) {
                  if (viewValue >= value || !viewValue) {
                     valid('minDate')
                     return viewValue
                  } else {
                     invalid('minDate', translationService.translations.FROM_DATE_BEFORE_TO)
                     return undefined
                  }
               } else {
                  valid('minDate')
                  return viewValue
               }
            })(viewValue)
         }

         if (!viewValue) { return undefined }

         // maxDate
         if (attrs.maxDate != null) {
            return viewValue = (function(viewValue){
               let value = scope
               for (var objName of attrs.maxDate.split('.')) { value = value[objName] }
               if (_.isDate(value)) {
                  if (viewValue <= value || !viewValue) {
                     valid('maxDate')
                     return viewValue
                  } else {
                     invalid('maxDate', translationService.translations.FROM_DATE_BEFORE_TO)
                     return undefined
                  }
               } else {
                  valid('maxDate')
                  return viewValue
               }
            })(viewValue)
         } else {
            return viewValue
         }
      })
   }
})

angular.module('summonApp.directives')
   .directive('parseDate', ['$locale', 'translationService', ParseDate])

